module.exports = __webpack_public_path__ + "media/images/landing/avatar7-3aa892f3cbacb44582c6181950cdb534.jpg";